import { Card, CardHeader } from '@fluentui/react-components';
import React from 'react';

import { createSuggestionMenuStyle } from '../suggestion-menu.modal.style';
import { TopResultCardProps } from '../suggestion-menu.model';
import { getTopResultCardHeading } from '../utils/suggestion-menu.utils';

const TopResultCard: React.FC<TopResultCardProps> = (props) => {
  const styles = createSuggestionMenuStyle();

  const handleClick = () => {
    props.onTopResultClickHandler?.(
      props.result.detailViewName,
      props.result.name,
      props.result.version,
      props.result.label,
      props.result.title,
      props.result.module
    );
  };

  return (
    <div
      onClick={handleClick}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          handleClick();
        }
      }}
      role="button"
      tabIndex={0}
      style={{ cursor: 'pointer', width: '100%' }}
    >
      <Card appearance="subtle">
        <CardHeader
          header={
            <div className={styles.cardHeader}>
              {getTopResultCardHeading(props.result)}
            </div>
          }
        />
      </Card>
    </div>
  );
};

export default TopResultCard;
